export default "__VITE_ASSET__7e1b3c0b__"